const urls = {
  baseUrl: (process && process.env.REACT_APP_BASEURL) || 'localhost',
  user: '/api/v1/users',
  password: '/api/v1/users/password',

  flights: '/api/v1/users/flights',
  registerFlight: '/api/v1/users/flight/register',
  userTier: '/api/v1/users/tiers',
  transferMile: '/api/v1/users/transfer',

  // convertMile: '/api/v1/users/convert-confirm',
  //calculateMile: '/api/v1/users/convert-calculate',
  purchase: '/api/v1/users/purchase/mile',
  departureRoute: '/api/v1/publics/routes/departures',
  destinationRoute: (query: string) => `/api/v1/publics/routes/destinations?q=${query}`,
  publicTier: '/api/v1/publics/tiers',
  tickets: '/api/v1/users/tickets',
  ticketDetail: (ticketId: string | number) => `/api/v1/users/tickets/${ticketId}/detail`,
  ticketSendMessage: (ticketId: string | number) => `/api/v1/users/tickets/${ticketId}/message`,
  awardTicket: '/api/v1/users/lowFareSearch',
  historyFreeTicket: '/api/v1/users/awardticket',
  createInquiry: `/api/v1/users/products/inquiry`,
  inquiryOtp: `/api/v1/users/products/inquiryOtp`,
  purchaseProduct: `/api/v1/users/products/purchase`,
  cancelProduct: `/api/v1/users/products/cancel`,
  // used
  users: '/',
  dashboard: '/dashboard',
  tiers: '/tiers',
  publiceTiers: '/publics/tiers',
  departureLocationsRoute: '/getAllDepartures',
  arrivalLocationsRoute: '/getArrivalByDeparture',
  airAvailRoute: '/airAvail',
  discountAirAvailRoute: '/discount-air-avail',
  airPrice: '/airPrice',
  discountAirPrice: '/discount-air-price',
  airBook: '/book',
  discountAirBook: '/discount-book',
  sendCodeByType: '/sendCodeByType',
  changeNumber: '/changeNumber',
  changeEmail: '/changeEmail',
  sendCode: '/sendCode',
  signup: '/signup',
  kidsSignup: '/kids-signup',
  login: '/login',
  forgotPassword: '/forgot-password',
  claimFlight: '/flights/claim',
  airlineProducts: '/airline-products',
  calculate: '/milage/calculate',
  calculateSpend: '/milage/calculate/spending',
  verifyEmail: '/email/verify',
  confirmedFlight: '/flights/confirm',
  transaction: '/transactions',
  discountType: '/discount-types',
  product: '/products',
  productBookings: '/products/productBookings',
  merchant: (id: string) => `/products/${id}/merchants`,
  calculateMile: '/convert-calculate',
  convertMile: '/convert-confirm',
  singleFreeTicket: (id: string) => `/awardticket/${id}`,
  kids: '/kids',
  changePasswordKids: (id: number | string) => `/kids/${id}/password`,
};

export default urls;
